export const ADD_SUCCESS = 'Новый хаб добавлен';
export const ADD_ERROR = 'Не удалось добавить хаб';
